export const APIs = {
	auth: {
		loginAsInternalUser: "token",
		refreshToken: "refresh-token",
		permissions: "permissions",
	},
	attorney: {
		validateAttorney: "validate",
	},
	applications: {
		getAll: "get-all",
		getApplicationDetails: "get-government-registration-details",
		getBusinessRegistrationDetails: "get-business-registration-details",
		approve: "approve",
		reject: "reject",
	},
	user: {
		getAll: "get-all",
		getUserDetails: "",
		getRoles: "roles",
		getRolesList: "departments",
		getRoleDetails: "departments",
		deleteRole: "departments",
		updateUserSupervisor: "update-user-supervisor",
		updateUserSpecialization: "update-user-specializations",
		updateRandomReferral: "update-random-referral",
		getSupervisors: "get-supervisors",
	},
	userManagement: {
		getAll: "users",
		getProfile: "GetProfile",
		getUserDetails: "",
		getRoles: "roles",
		getRolesList: "departments",
		getRoleDetails: "departments",
		deleteRole: "departments",
		updateUserSpecialization: "update-user-specializations",
		updateRandomReferral: "update-random-referral",
		createUser: "users",
		updateUser: "users",
		deleteUser: "users",
		getAllDirectorates: "GetAlldirectorates",
		getDirectorates: "directorates",
		getDirectorateById: "directorates",
		createDirectorate: "directorates",
		updateDirectorate: "directorates",
		deleteDirectorate: "directorates",
		updateDirectorateStatus: "directorates",
		getDepartments: "departments",
		createDepartment: "departments",
		updateDepartment: "departments",
		deleteDepartment: "departments",
		updateDepartmentStatus: "departments",
		createRole: "roles",
		updateRole: "roles",
		updateRoleStatus: "roles",
		updateUserPermissions: "permissions",
		externalUsers: "external-users",
		updateExternalUserPermissions: "permissions",
	},
	lawsuits: {
		get: "get",
		getCombined: "combined",
		getRequestAuditLog: "audit-logs",
		getLegalStudyReturnNotes: "legal-study-notes",
		validateUser: "get-user-authorities",
		violationCategory: "violation-category",
		createRequest: "create-request",
		resubmitRequest: "resubmit-request",
		getUserRequestTypes: "get-user-requesttypes",
		getSpecializationExeptHeritageAuthority: "get-specialization-exept-HeritageAuthority",
		getRequestsAssignedToUser: "assigned-to-user",
		getRequestsByCodes: "by-codes",
		referMultipleRequestsToUser: "refer-multiple",
		checkActiveComplaint: "check-active-complaint",
		classifyViolation: "violation-classification",
		refineDescription: "description-refinement",
		aiRecommendation: "ai-recommendation",
		updateRequest: "update-request",
		AdditionalStatement: "additional-statement",
		SendStatementReminder: "send-statement-reminder",
		updateReferralLetter: "update-referral-letter",
		addPoliceReportData: "police-report-data",
	},
	requestUnderReview: {
		approve: "approve",
		reject: "reject",
		return: "return",
	},
	legalStudy: {
		approve: "approve",
		SaveLegalOpinion: "save-legal-opinion",
		GetRequestLegalStudy: "get-request-legal-study",
		return: "return",
		sendLegalOpinion: "send-legal-opinion",
	},
	complaintStudy: {
		get: "get-complaint-study",
		save: "save-complaint-study",
		send: "send-complaint-study",
		requestDefendantStatement: "request-defendant-statement",
		returnForStudy: "return-for-study",
		requestCompletionRequirements: "request-completion-requirements",
		saveReferralLetter: "save-referral-letter",
	},
	memos: {
		createMemo: "create-memo",
		createReply: "create-reply",
	},
	frequentlyAskedQuestions: {
		getAll: "get-all",
	},
	holidays: {
		getAll: "get-all",
	},
	feedback: {
		getAll: "get-all",
		accept: "accept",
		reject: "reject",
	},
	session: {
		saveSessionRecord: "save-session-record",
		approveSessionRecord: "approve-session-record",
		returnSessionRecord: "return-session-record",
		sendSessionRecord: "send-session-record",
		getSessionRecord: "get-request-session-record",
	},
	requestSessions: {
		getRequestSessionInfo: "get-request-session-info",
		getRequestSessionParticipants: "get-request-session-participants",
		updateRequestSessionAttendance: "update-request-session-attendance",
		createPlan: "create-plan",
		getEditSessionDetails: "get-edit-session-details",
		addSession: "add-session",
		editSession: "edit-session",
		deleteSession: "delete-session",
		joinSession: "join-session",
		addAttachment: "add-session-attachment",
		getAttachments: "attachments",
		getAttachmentDetails: "attachments/details",
		approveAttachment: "approve",
		rejectAttachment: "reject",
		getLeaders: "get-leaders",
		getMembers: "get-members",
		approveMinutes: "approve-minutes",
		downloadMinutes: "Attachment",
	},
	requestDecision: {
		saveDecision: "save-request-decision",
		approveDecision: "approve-request-decision",
		returnDecision: "return-request-decision",
	},
	requestDecisionSecretary: {
		issueFinalDecision: "issue-final-decision",
	},
	complaints: {
		getComplaints: "get-complaints",
		createComplaints: "create-complaint",
		returnComplaints: "return-complaint",
		closeComplaints: "close-complaint",
		cancelComplaints: "cancel-complaint",
		sendComplaints: "send-complaint",
		editComplaints: "edit-complaint",
	},
	requests: {
		getAll: "",
		attachments: "attachments",
		attachmentsAccess: "attachments/access",
		attachmentRelevance: "relevance",
		attachmentReferences: "references",
		correspondences: "correspondences",
		investigationCorrespondences: "investigation-correspondences",
		prosecutionCorrespondences: "prosecution/correspondences",
		disciplineCorrespondences: "discipline-committee/correspondences",
		details: "details",
		previousStudies: "previous-studies",
		followUpStudy: "follow-up-study",
		followUpStudyOptions: "follow-up-study/options",
		followUpStudyDraft: "follow-up-study/draft",
		followUpStudySubmit: "follow-up-study/submit",
		followUpStudyRecommendation: "follow-up-study/recommendation",
		followUpStudyCompletionRequest: "follow-up-study/completion-request",
		followUpStudyCompletionItems: "follow-up-study/completion-request/items",
		followUpStudyPreparationMethod: "follow-up-study/preparation-method",
		followUpStudyRegenerate: "follow-up-study/regenerate",
		followUpStudySimilarFiles: "follow-up-study/similar-files",
		gladAiFollowUpStudy: "glad-ai/follow-up-study",
		gladAiFollowUpStudyRegenerate: "glad-ai/follow-up-study/regenerate",
		gladAiStudiesComparison: "glad-ai/studies/comparison",
		gladAiInvestigationSessions: "glad-ai/investigation-sessions",
		gladAiCalls: "glad-ai/calls",
		gladAiProsecutionStatement: "glad-ai/prosecution-statement",
		gladAiCommitteeDecisionNote: "glad-ai/committee-decision-note",
		studyComparison: "study-comparison",
		studyComparisonVersions: "study-comparison/versions",
		studyComparisonComparisons: "study-comparison/comparisons",
		studyComparisonAddenda: "study-comparison/addenda",
		disciplineLegalStudy: "discipline-legal-study",
		disciplineCommittee: "discipline-committee",
		disciplineDecision: "discipline-decision",
		disciplineDecisionDraft: "discipline-decision/draft",
		disciplineDecisionSubmit: "discipline-decision/submit",
		disciplineDecisionCopy: "discipline-decision/pdfcopy",
		disciplineDecisionAiGenerate: "discipline-decision/ai-generate",
		disciplineDecisionReturnRecipients: "discipline-decision-review/return-recipients",
		disciplineDecisionApprove: "discipline-decision-review/approve",
		disciplineDecisionReturn: "discipline-decision-review/return",
		disciplineDecisionSign: "discipline-decision-review/sign",
		disciplineChairmanDecisionReturnRecipients: "discipline-chairman-decision/return-recipients",
		disciplineChairmanDecisionApproveAndSign: "discipline-chairman-decision/approve-and-sign",
		disciplineChairmanDecisionReturn: "discipline-chairman-decision/return",
		disciplineLegalStudyDraft: "discipline-legal-study/draft",
		disciplineLegalStudySubmit: "discipline-legal-study/submit",
		disciplineLegalStudyGenerate: "discipline-legal-study/generate",
		disciplineLegalStudyReturnRecipients: "discipline-legal-study-review/return-recipients",
		disciplineLegalStudyReturn: "discipline-legal-study-review/return",
		disciplineLegalStudyApprove: "discipline-legal-study-review/approve",
		prosecution: "prosecution",
		prosecutionApprove: "prosecution/approve",
		prosecutionDraft: "prosecution/draft",
		prosecutionReturn: "prosecution/return",
		prosecutionReturnOptions: "prosecution/return-options",
		prosecutionReturnNotes: "prosecution/return-notes",
		prosecutionMemos: "prosecution-memos",
		investigationPlan: "investigation-plan",
		investigationPlanLog: "investigation-plan/log",
		investigationPlanQuestions: "investigation-plan/questions",
		investigationPlanDocuments: "investigation-plan/documents",
		investigationPlanSessions: "investigation-plan/sessions",
		investigationPlanSend: "investigation-plan/send",
		investigationPlanSabr: "investigation-plan/sabr",
		investigationReport: "investigation-report",
		investigationReportDraft: "investigation-report/draft",
		investigationReportSubmit: "investigation-report/submit",
		investigationReportSabr: "investigation-report/sabr",
		investigationReportSabrApprove: "investigation-report/sabr/approve",
		investigationReportLetter: "investigation-report/recommendation-letter",
		investigationReportReturn: "investigation-report/return",
		investigationReportSupplementary: "investigation-report/supplementary",
		investigationReportSupplementaryIssues: "investigation-report/supplementary/issues",
		investigationReportSupplementaryAddendum: "investigation-report/supplementary/addendum",
		insafDeliveries: "insaf-deliveries",
		versionUpdates: "version-updates",
	},
	disciplineSessions: {
		root: "sessions",
		name: "name",
		schedule: "schedule",
		cancel: "cancel",
		start: "start",
		join: "join",
		attendance: "attendance",
		attachments: "attachments",
		record: "record",
		recordFile: "record/file",
		recordApprove: "record/approve",
		recordAuthenticate: "record/authenticate",
		recordViews: "record/views",
		recordPdf: "record/pdf",
		questions: "questions",
		batches: "batches",
		proveNonResponse: "prove-non-response",
		renotify: "renotify",
		extend: "extend",
		requestAccept: "request/accept",
		requestReject: "request/reject",
	},
	investigationSessions: {
		root: "investigation-sessions",
		reschedule: "reschedule",
		cancel: "cancel",
		start: "start",
		attendance: "attendance",
		questions: "questions",
		answer: "answer",
		attachments: "attachments",
		signedMinutes: "signed-minutes",
		minutes: "minutes",
		minutesCopy: "minutes/copy",
		minutesApprove: "minutes/approve",
		minutesSabr: "minutes/sabr",
		batches: "batches",
		nonResponseDecision: "non-response-decision",
		requests: "requests",
		decision: "decision",
		deadlinePreview: "deadline-preview",
	},
	auditLog: {
		getGeneralActions: "Get-General-Actions",
		exportGeneralActions: "Export-General-Actions",
		getTransactionActions: "Get-Transaction-Actions",
		exportTransactionActions: "Export-Transaction-Actions",
	},
	reports: {
		getFilteredRequestsReport: "Get-Filtered-Requests",
		exportFilteredRequestsReport: "Export-Filtered-Requests",

		getFilteredComplaintsReport: "Get-Filtered-Complaints-Report",
		exportFilteredComplaintsReport: "Export-Filtered-Complaints-Report",

		getFilteredNoticesReport: "Get-Filtered-Notices-Report",
		exportFilteredNoticesReport: "Export-Filtered-Notices-Report",

		getFilteredProfessionalMonitoringReport: "Get-Filtered-Professional-Monitoring-Report",
		exportFilteredProfessionalMonitoringReport: "Export-Filtered-Professional-Monitoring-Report",

		getFilteredUsersReport: "Get-Filtered-Users",
		exportFilteredUsersReport: "Export-Filtered-Users",

		getFilteredBeneficiariesReport: "Get-Filtered-Beneficiaries",
		exportFilteredBeneficiariesReport: "Export-Filtered-Beneficiaries",

		getRequestsStatusReport: "Get-Requests-Status-Report",
		exportRequestsStatusReport: "Export-Requests-Status-Report",

		getReferredToDepartmentReport: "Get-Referred-To-Department-Report",
		exportReferredToDepartmentReport: "Export-Referred-To-Department-Report",

		getUnderReviewReport: "Get-Under-Review-Report",
		exportUnderReviewReport: "Export-Under-Review-Report",

		getAwaitingStatementReport: "Get-Awaiting-Statement-Report",
		exportAwaitingStatementReport: "Export-Awaiting-Statement-Report",

		getAwaitingRequirementsReport: "Get-Awaiting-Requirements-Report",
		exportAwaitingRequirementsReport: "Export-Awaiting-Requirements-Report",

		getReferredToPoliceReport: "Get-Referred-To-Police-Report",
		exportReferredToPoliceReport: "Export-Referred-To-Police-Report",

		getSavedRequestsReport: "Get-Saved-Requests-Report",
		exportSavedRequestsReport: "Export-Saved-Requests-Report",

		getFilteredSmsLogsReport: "Get-Filtered-Sms-Logs",
		exportFilteredSmsLogsReport: "Export-Filtered-Sms-Logs",

		exportTransactionLifespanReport: "Export-Transaction-Lifespan-Report",
		exportTransactionAgeTable: "Export-Transaction-Age-Table",
	},
	statisticsReports: {
		getStatisticsKpis: "Get-Statistics-Kpis",
		getStatisticsRegions: "Get-Statistics-Regions",
		getAverageCompletionDurationByEmployee: "Get-Average-Completion-Duration-By-Employee",
		getTicketsByClassification: "Get-Tickets-By-Classification",
		getTicketsByTypeAndStatus: "Get-Tickets-By-Type-And-Status",
		getTicketsDistributionByStatus: "Get-Tickets-Distribution-By-Status",
		getTicketsByRegion: "Get-Tickets-By-Region",
	},
	workflow: {
		getAllProcesses: "processes",
		createProcess: "processes",
		updateProcess: "processes",
		deleteProcess: "processes",
		getActivities: "activities",
		createActivity: "activities",
		updateActivity: "activities",
		deleteActivity: "activities",
		getActions: "actions",
		createAction: "actions",
		updateAction: "actions",
		deleteAction: "actions",
		getTransitions: "transitions",
		createTransition: "transitions",
		updateTransition: "transitions/update",
		deleteTransition: "transitions",
		getActivityActions: "activity-actions",
		createActivityActions: "activity-actions",
		deleteActivityActions: "activity-actions",
		getActivityRoles: "activity-roles",
		createActivityRoles: "activity-roles",
		deleteActivityRoles: "activity-roles",
		getRequestStatuses: "request-statuses",
		createRequestStatuses: "request-statuses",
		updateRequestStatuses: "request-statuses",
		deleteRequestStatuses: "request-statuses",
		getRequestsActive: "requests/active",
	},
	lookup: {
		getRequestStatuses: "request-statuses",
		createRequestStatuses: "request-statuses",
		updateRequestStatuses: "request-statuses",
		deleteRequestStatuses: "request-statuses",
		pagesActionsTree: "pages-actions-tree",
	},
};
